// prettier-ignore
import { DomainVerification, EmailKey, Group, GroupKey, InboundEmail, MailboxKey, Member, MemberKey, Org, OrgKey, Owner, OwnerKey, UserKey, UserProfile, firestorePaths } from "@zickko/shared";

import { CollectionRepo } from "./CollectionRepo";
import { DocumentRepo } from "./DocumentRepo";
import { OutboundEmail } from "@zickko/shared/src/models/OutboundEmail";
import { TrashEmail } from "@zickko/shared/src/models/TrashEmail";
import { DraftEmail } from "@zickko/shared/src/models/DraftEmail";

export const clientRepo = {
  userProfile: new DocumentRepo<UserKey, UserProfile>(firestorePaths.userProfile),
  orgs: new CollectionRepo<{}, Org>(firestorePaths.orgs),
  org: new DocumentRepo<OrgKey, Org>(firestorePaths.org),
  members: new CollectionRepo<OrgKey, Member>(firestorePaths.members),
  member: new DocumentRepo<MemberKey, Member>(firestorePaths.member),
  groups: new CollectionRepo<OrgKey, Group>(firestorePaths.groups),
  group: new DocumentRepo<GroupKey, Group>(firestorePaths.group),
  owners: new CollectionRepo<OrgKey, Owner>(firestorePaths.owners),
  owner: new DocumentRepo<OwnerKey, Owner>(firestorePaths.owner),
  domainVerifications: new CollectionRepo<{}, DomainVerification>(firestorePaths.domainVerifications),
  domainVerification: new DocumentRepo<OrgKey, DomainVerification>(firestorePaths.domainVerification),

  inbox: new CollectionRepo<MailboxKey, InboundEmail>(firestorePaths.inbox),
  inboundEmail: new DocumentRepo<EmailKey, InboundEmail>(firestorePaths.inboundEmail),
  outbox: new CollectionRepo<MailboxKey, OutboundEmail>(firestorePaths.outbox),
  outboundEmail: new DocumentRepo<EmailKey, OutboundEmail>(firestorePaths.outboundEmail),
  archive: new CollectionRepo<MailboxKey, InboundEmail>(firestorePaths.archive),
  archiveEmail: new DocumentRepo<EmailKey, InboundEmail>(firestorePaths.archiveEmail),
  drafts: new CollectionRepo<MailboxKey, DraftEmail>(firestorePaths.drafts),
  draftEmail: new DocumentRepo<EmailKey, DraftEmail>(firestorePaths.draftEmail),
  trash: new CollectionRepo<MailboxKey, TrashEmail>(firestorePaths.trash),
  trashEmail: new DocumentRepo<EmailKey, TrashEmail>(firestorePaths.trashEmail),
};
